export default __webpack_public_path__ + "static/media/8.d2126e43.png";